import gql from "graphql-tag";

export const editedCollectionData = gql`
  mutation editedCollectionData(
    $input: EditedCollectionDataInput!) {
    editedCollectionData(input: $input) {
      project {
        id
        updatedAt
        collections {
          id
          index
          syncing
          syncedAt
          encoding
          encodedAt
          changed
          changedAt
        }
      }
    }
  }
`;

export const editedCollectionDataOptions = {
  name: "editedCollectionData",
};
